<base-index-page
    [config]="baseIndexPageConfig"
    [service]="antivirusFileUploadLogService"
    [idKey]="'id'"
></base-index-page>
